/**
 * Périmètre d'inspection — miroir des DTO `InspectionScopeDto` / `SaveInspectionScopeDto`.
 *
 * Un attribut du compte, pas du profil : tout l'établissement, ou des matières
 * choisies niveau par niveau. C'est le serveur qui l'applique ; l'écran le
 * compose (accès) et le reflète (inspection).
 */
export interface InspectionScopeItem {
  learningPathId: number;
  subjectId: number;
  learningPathTitle?: string | null;
  learningPathTitleAr?: string | null;
  learningPathTitleFr?: string | null;
  learningPathTitleEn?: string | null;
  subjectName?: string | null;
  subjectNameAr?: string | null;
  subjectNameFr?: string | null;
  subjectNameEn?: string | null;
}

export interface InspectionScope {
  /** Tout l'établissement : `items` est alors sans objet. */
  all: boolean;
  items: InspectionScopeItem[];
}

/** Ce que le superviseur enregistre. */
export interface SaveInspectionScope {
  all: boolean;
  items: { learningPathId: number; subjectId: number }[];
}

export const EMPTY_SCOPE: InspectionScope = { all: false, items: [] };

/** Vrai quand le compte n'a encore rien reçu : l'espace Inspection s'ouvre mais ne montre rien. */
export function isEmptyScope(scope: InspectionScope | null | undefined): boolean {
  return !scope || (!scope.all && scope.items.length === 0);
}
